export const ComponentSize = Object.freeze({
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
});
